module.exports = __webpack_public_path__ + "47eff2f2df7305f1854cd2e330ebacbc.svg";